import { render, staticRenderFns } from "./sideBar.vue?vue&type=template&id=7d811861"
import script from "./sideBar.vue?vue&type=script&lang=js"
export * from "./sideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports